import React from 'react'
import { useRandomId } from '@fs/zion-frontend-friends'

export default function FaceFeature({ scaleX, scale, fill, spacing, rotation, gradient, verticalOffset }) {
  const randomGradientId1 = `_${useRandomId()}`
  const randomGradientId2 = `_${useRandomId()}`

  const leftTransformOrigin = '9.9201 7.6069'
  const rightTransformOrigin = '42.7801 7.6069'

  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g
        transform={`translate(${-spacing}) rotate(${rotation}) scale(${scale},${scale})`}
        transform-origin={leftTransformOrigin}
      >
        <path
          d="M0 9.53693C0 9.53693 3.89001 8.49693 5.76001 7.50693C7.63001 6.51693 18.5 10.0869 18.5 10.0869V4.14693C18.5 4.14693 8.38001 1.49693 5.76001 2.81693C3.15001 4.13693 0 9.53693 0 9.53693Z"
          fill={`url(#${randomGradientId1})`}
        />
        <path
          d="M1.14014 7.60694C1.14014 7.60694 4.09014 4.75694 5.96014 3.76694C7.83014 2.77694 18.7001 6.34693 18.7001 6.34693V0.406942C18.7001 0.406942 8.58014 -0.283069 5.96014 1.03693C3.34014 2.35693 1.14014 7.60694 1.14014 7.60694Z"
          fill={fill}
        />
      </g>
      <g
        transform={`translate(${spacing}) rotate(${-rotation}) scale(${scale},${scale})`}
        transform-origin={rightTransformOrigin}
      >
        <path
          d="M52.7002 9.53693C52.7002 9.53693 48.8102 8.49693 46.9402 7.50693C45.0702 6.51693 34.2002 10.0869 34.2002 10.0869V4.14693C34.2002 4.14693 44.3202 1.49693 46.9402 2.81693C49.5502 4.13693 52.7002 9.53693 52.7002 9.53693Z"
          fill={`url(#${randomGradientId2})`}
        />
        <path
          d="M51.5601 7.60694C51.5601 7.60694 48.6101 4.75694 46.7401 3.76694C44.8701 2.77694 34 6.34693 34 6.34693V0.406942C34 0.406942 44.1201 -0.283069 46.7401 1.03693C49.3601 2.35693 51.5601 7.60694 51.5601 7.60694Z"
          fill={fill}
        />
        <defs>
          <linearGradient
            id={randomGradientId1}
            x1="9.2501"
            y1="11.4079"
            x2="9.2501"
            y2="4.46647"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
          <linearGradient
            id={randomGradientId2}
            x1="43.4501"
            y1="11.4079"
            x2="43.4501"
            y2="4.46647"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0.2877" stopColor={gradient[1]} stopOpacity="0" />
            <stop offset="0.8775" stopColor={gradient[0]} />
          </linearGradient>
        </defs>
      </g>
    </g>
  )
}
